import React, { PureComponent } from 'react';
import { debounce, noop } from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import FormField from 'components/form/form-field-input';
import Loader from 'components/loader';
import Button from 'components/button';
import t, { Trans } from 'translations';
import Icon from 'components/icon';
import Collapsible from 'react-collapsible';
import EmailInput from 'components/email-input';

class PrelaunchForm extends PureComponent {
    static defaultProps = {
        hasAccordion: true,
        onHeightChange: noop,
        autoFocus: true,
    };

    static propTypes = {
        isSendingSubscription: PropTypes.bool.isRequired,
        subscribe: PropTypes.func.isRequired,
        onHeightChange: PropTypes.func,
        closeModal: PropTypes.func,
        autoFocus: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            valid: false,
            numberIsValid: false,
            emailIsValid: false,
            zip: '',
            email: '',
            isSent: false,
        };
    };

    onEmailChange = ({ email, isValid }) => {
        this.setState({ email, emailIsValid: isValid }, () => this.validateForm());
    };

    clearNumberInput = () => {
        this.setState({ zip: '', numberIsValid: false }, () => this.validateForm());
    };


    handleNumberInput = e => {
        if (e.length <= 4) {
            this.setState({ zip: e });
        }
        if (e.length === 4) {
            this.setState({ numberIsValid: true }, () => this.validateForm());
        }
    };

    handleSubmit = e => {
        e.preventDefault();
        const { zip, email } = this.state;
        this.props.subscribe({ email, zip }).then(() => {
            this.setState({ isSent: true });
            this.props.onHeightChange();
        });
    };

    validateForm = () => {
        if (this.state.emailIsValid && this.state.numberIsValid) {
            this.setState({ valid: true });
        } else {
            this.setState({ valid: false });
        }
    };

    renderAccordion() {
        return (
            <Collapsible
                onOpen={this.props.onHeightChange}
                onClose={debounce(this.props.onHeightChange, 50)}
                classParentString="prelaunch-form--accordion"
                transitionTime={5}
                trigger={this.renderTrigger()}
            >
                <div className="prelaunch-form--accordion-content">
                    <h2 className="prelaunch-form--accordion-title">
                        <Trans path="zip.accordion.title"/>
                    </h2>
                    <p className="prelaunch-form--paragraph">
                        <Trans path="zip.accordion.text"/>
                    </p>
                </div>
            </Collapsible>
        );
    }

    renderTrigger() {
        return (
            <div className="prelaunch-form--accordion-trigger">
                <div className="prelaunch-form--accordion-trigger-text">
                    <Trans path="zip.accordion.trigger"/>
                </div>
                <Icon className="prelaunch-form--accordion-icon" size="small" symbol="chevron-down"/>
            </div>
        );
    }

    render() {
        const { autoFocus, isSendingSubscription } = this.props;
        const { zip, email, isSent, valid } = this.state;

        return (
            <div ref="root" className="prelaunch-form">
                <div className="prelaunch-form--content">
                    <h2 className="prelaunch-form--title">
                        <Trans path={'prelaunch.modal.title'}/>
                    </h2>
                    {isSent ? (
                        <div className="prelaunch-form--success">
                            <Trans path={'prelaunch.modal.success'}/>
                        </div>
                    ) : (
                        <form onSubmit={this.handleSubmit}>
                            <div className="prelaunch-form--row">
                                <div className="prelaunch-form--col-zip prelaunch-form--input-wrapper">
                                    <FormField
                                        type="number"
                                        name="zip"
                                        value={zip}
                                        autoFocus={autoFocus}
                                        hasFloatingLabel={true}
                                        label={t('zip.form.placeholder')}
                                        onInput={this.handleNumberInput}
                                        tabIndex={1}
                                        hasClearAction={this.clearNumberInput}
                                    />
                                </div>
                                <div className="prelaunch-form--col-email prelaunch-form--input-wrapper">
                                    <EmailInput
                                        onChange={this.onEmailChange}
                                        tabIndex={2}
                                        value={email}
                                        label={t('zip.email')}
                                    />
                                </div>
                            </div>
                            <div className="prelaunch-form--row">
                                <Button
                                    hasFocus={isSendingSubscription}
                                    size="medium"
                                    className="prelaunch-form--form-button prelaunch-form--form-button__zip"
                                    facet="primary"
                                    disabled={!valid}
                                >
                                    {isSendingSubscription ? (
                                        <Loader size="small"/>
                                    ) : (
                                        <Trans path={'prelaunch.modal.submit'}/>
                                    )}
                                </Button>
                            </div>
                        </form>
                    )}
                </div>
                {this.renderAccordion()}
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        isSendingSubscription: 'subscription.isFetching',
        routeName: 'router.name',
    }),
    reduxUtils.mapDispatchToProps({
        setRegion: 'region.setRegion',
        subscribe: 'subscription.subscribePrelaunch',
        closeModal: 'modal.close',
    }),
)(PrelaunchForm);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/prelaunch-form/index.js